<img [hfSrcset]="getThumbnailUrl()" [alt]="attachment.originalFilename" />

<span>{{ attachment.originalFilename }}</span>

<i class="material-icons" (click)="$event.preventDefault(); removeClick.next()">close</i>
